import {defaultQueryOptions} from '@/pages/_utils';
import {useTable} from '@refinedev/core';
import {ConversationLayout} from '../conversations/conversation-layout';
import React, {useCallback, useMemo} from 'react';
import {ConversableObject, ConversationContext} from './types';

const ConversationView = (props: ConversableObject) => {
  const {owner_type, owner_id} = props;

  const conversationResults = useTable({
    resource: `${owner_type}s/${owner_id}/conversations`,
    sorters: {initial: [{field: 'id', order: 'asc'}]},
    // filters: {
    //   permanent: [{field: owner_type + '_id', operator: 'eq', value: owner_id}],
    // },
    queryOptions: {
      ...defaultQueryOptions,
    },
    errorNotification: false,
    // meta: {with: ['members']},
  });

  const conversations = useMemo(
    () => conversationResults.tableQuery.data?.data || [],
    [conversationResults.tableQuery.data],
  );

  const refetchConversations = useCallback(() => {
    conversationResults.tableQuery.refetch();
  }, [conversationResults.tableQuery]);

  const [activeConversation, setActiveConversation] = React.useState<any>(undefined);

  return (
    <ConversationContext.Provider
      value={{
        owner_type,
        owner_id,
        conversations,
        refetchConversations,
        activeConversation,
        setActiveConversation,
      }}>
      <ConversationLayout defaultLayout={[240, 360]} />
    </ConversationContext.Provider>
  );
};

export default ConversationView;
